type storageType = 'sessionStorage' | 'localStorage';

export function getItem(key: string, storageType: storageType = 'sessionStorage'): any {
  try {
    const storageItem = window[storageType].getItem(key);
    return storageItem ? JSON.parse(storageItem) : null;
  } catch (e) {
    console.error('Web Storage API is not supported', e);
    return null;
  }
}

export function setItem(key: string, value: unknown, storageType: storageType = 'sessionStorage'): any {
  try {
    window[storageType].setItem(key, JSON.stringify(value));
  } catch (e) {
    console.error('Web Storage API is not supported', e);
  }
}

export function removeItem(key: string, storageType: storageType = 'sessionStorage'): any {
  try {
    window[storageType].removeItem(key);
  } catch (e) {
    console.error('Web Storage API is not supported', e);
  }
}
